import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-report-instance-details',
    templateUrl: './report-instance-details.component.html',
    styleUrls: ['./report-instance-details.component.scss'],
    standalone: false
})
export class ReportInstanceDetailsComponent implements OnInit {

  navLinks: any[];
  activeLinkIndex = -1;

  constructor(
    private router: Router
  ) { 
    this.navLinks = [
      // {
      //   label: 'Pending',
      //   link: './reportInstanceUpcoming',
      //   index: 0
      // }, 
      {
        label: 'Generated Reports',
        link: './reportInstanceHistory',
        index: 0
      },
      {
        label: 'Upcoming Reports',
        link: './reportInstanceUpcoming',
        index: 1
      }
      
    ];
  }

  ngOnInit() {
    this.router.events.subscribe((res) => {
      this.activeLinkIndex = this.navLinks.indexOf(this.navLinks.find(tab => tab.link === '.' + this.router.url));
    });
  }

}
